// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

var Chartblock = require('../_modules/data/chartblock/chartblock');
var Table = require('../_modules/data/table/table');
var TableSection1 = require('../_modules/data/table/table.section1');
var TableSection4 = require('../_modules/data/table/table.section4');
var Tablesection5 = require('../_modules/data/table/table.section5');

var Header = require('../_modules/home/header/header');
var Slides = require('../_modules/home/slides/slides');
var Slide1 = require('../_modules/home/slide1/slide1');
var Slide2 = require('../_modules/home/slide2/slide2');
var Slide3 = require('../_modules/home/slide3/slide3');
var Slide4 = require('../_modules/home/slide4/slide4');
var Slide5 = require('../_modules/home/slide5/slide5');
var Slider = require('../_modules/home/slider/slider');
var CommonHeader = require('../_modules/common/header/header');
var TitleBar = require('../_modules/common/title-bar/title-bar');
var CollapsibleBox = require('../_modules/common/collapsible-box/collapsible-box');
var PageScroll = require('../_modules/common/page-scroll/page-scroll');
var TabBox = require('../_modules/common/tab-box/tab-box');
var MainNavigation = require('../_modules/common/main-navigation/main-navigation');


// Reset the chart array
window.charts_collection = [];


$(function() {
  new Chartblock();
  new Table();
  new TableSection1();
  new TableSection4();
  new Tablesection5();
  
  new CommonHeader();
  new CollapsibleBox();
  new TabBox();
  new MainNavigation();
  new PageScroll();
  new TitleBar();
  
  new Header();
  new Slides();
  new Slide1();
  new Slide2();
  new Slide3();
  new Slide4();
  new Slide5();
  new Slider();
});
